var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Heading } from '../heading';
import { useCard } from './card-context';
import { headerHeadingStaticStyle } from './styles';
const sizeMap = {
    large: 'xlarge',
    medium: 'large',
};
function Header(_a) {
    var { as = 'h3', children, decor } = _a, restProps = __rest(_a, ["as", "children", "decor"]);
    const { size } = useCard();
    const headingProps = Object.assign({ size: sizeMap[size] }, Object.assign({ as }, restProps));
    return decor !== undefined ? (_jsxs(Heading, Object.assign({ css: headerHeadingStaticStyle }, headingProps, { children: [decor, children] }))) : (_jsx(Heading, Object.assign({}, headingProps, { children: children })));
}
export default Header;
